import { FC, HTMLAttributes } from "react";

import { IDropdownItem } from "@ryde/shared";

import {
  findPriceRateSearchDropdownItem,
  formatPriceRateSearchSupplierPriority,
  resolvePriceRateSearchDropdownItemLabel,
} from "./price-rate-search-logs.utils";

export const PriceRateSearchSupplierAutocompleteOption: FC<{
  id: number;
  options: IDropdownItem[];
  idLabel: string;
  priorityLabel: string;
  liProps: HTMLAttributes<HTMLLIElement>;
}> = ({ id, options, idLabel, priorityLabel, liProps }) => {
  const item = findPriceRateSearchDropdownItem(options, id);
  const name = resolvePriceRateSearchDropdownItemLabel(options, id);
  const priority = formatPriceRateSearchSupplierPriority(item);

  return (
    <li {...liProps}>
      <div className="price-rate-search-autocomplete-option">
        <div className="price-rate-search-autocomplete-option__primary">
          {name}
        </div>
        <div className="price-rate-search-autocomplete-option__secondary">
          {`${idLabel}: ${id} · ${priorityLabel}: ${priority}`}
        </div>
      </div>
    </li>
  );
};

export const PriceRateSearchVehicleTypeAutocompleteOption: FC<{
  id: number;
  options: IDropdownItem[];
  idLabel: string;
  liProps: HTMLAttributes<HTMLLIElement>;
}> = ({ id, options, idLabel, liProps }) => {
  const name = resolvePriceRateSearchDropdownItemLabel(options, id);

  return (
    <li {...liProps}>
      <div className="price-rate-search-autocomplete-option">
        <div className="price-rate-search-autocomplete-option__primary">
          {name}
        </div>
        <div className="price-rate-search-autocomplete-option__secondary">
          {`${idLabel}: ${id}`}
        </div>
      </div>
    </li>
  );
};

export const PriceRateSearchSupplierEntityMeta: FC<{
  supplierId: number | null | undefined;
  supplierOptions: IDropdownItem[];
  idLabel: string;
  priorityLabel: string;
}> = ({ supplierId, supplierOptions, idLabel, priorityLabel }) => {
  if (!supplierId) {
    return null;
  }
  const item = findPriceRateSearchDropdownItem(supplierOptions, supplierId);
  const priority = formatPriceRateSearchSupplierPriority(item);

  return (
    <div className="price-rate-search-rate-card__entity-meta">
      {`${idLabel}: ${supplierId} · ${priorityLabel}: ${priority}`}
    </div>
  );
};
